import { useGetProjectQuery, useProjectId } from '@consigli/hooks';
import { FC } from 'react';
import { Outlet } from 'react-router';

import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { Route } from '@/routes';

export const ServiceListWrapper: FC = () => {
  const projectId = useProjectId();
  // Refetched on every mount: the project list seeds this entry so the page
  // draws at once, and every useProject under this route reads the fresh
  // response when it lands.
  const { data: project } = useGetProjectQuery({ projectId }, { refetchOnMountOrArgChange: true });
  return (
    <>
      {/* The legacy crumb, repointed with the other three internal links for
          consistency. It is a portal into PageHeader, so it renders only when
          PageHeader is not suppressed — which under the flag it always is, and
          without the flag /agents forwards straight back here. */}
      <Breadcrumb
        label={project?.name ?? ''}
        to={`/${Route.PROJECTS}/${projectId}/${Route.AGENTS}`}
      />
      <Outlet />
    </>
  );
};
